export default "__VITE_ASSET__964d3a53__"